var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-map-wrapper"},[_c('div',{ref:"mapWrapper",staticClass:"map-wrapper",attrs:{"id":_vm.mapId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }